import axios from 'axios';

import { app } from '../main';
import store from '../store';

const token = localStorage.getItem('access-token');
const locale = localStorage.getItem('locale');

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    authorization: token ? `JWT ${token}` : null,
    'Accept-Language': locale || 'ru',
  },
});

axiosInstance.interceptors.request.use(
  config => config,
  error => {
    app.$bvToast.toast(error.message, {
      title: app.$t('error'),
      variant: 'danger',
      solid: true,
      autoHideDelay: 15000,
    });
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  response => {
    if (response.config.responseType === 'blob') {
      return response;
    }
    return response.data;
  },
  async error => {
    let errorMessage = null;
    let errorTitle = null;

    if (!error.response) {
      errorTitle = 'Network error';
      errorMessage = error.message || 'Невозможно связаться с сервером.';
    }

    if (error.response && error.response.status === 401 && localStorage.getItem('access-token')) {
      store.commit('logOut', window.location.pathname);
    }

    if (error.response && error.response.status === 403) {
      errorTitle = error.message;
      errorMessage = 'Access denied';
    }

    if (error.response && error.response.status === 404) {
      errorTitle = error.message;
      errorMessage = 'Not found';
    }

    if (error.response && error.response.status === 500) {
      errorTitle = error.message;
      errorMessage = 'Server error';
    }

    if (error.response && error.response.status === 400) {
      errorTitle = error.message;
      errorMessage = Object.entries(error.response.data)
        .map(([key, value]) => `${key}: ${value}`)
        .join(', ');
    }

    let autohideDelay = 20000;
    if (error.response) {
      if (error.response.data['@validation']) {
        errorTitle = app.$t('Error');
        errorMessage = app.$t('fields_not_provided');
        autohideDelay = 5000;
      }
    }

    if (errorMessage) {
      app.$bvToast.toast(errorMessage, {
        title: errorTitle,
        variant: 'danger',
        solid: true,
        autoHideDelay: autohideDelay,
      });
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
